import { render, staticRenderFns } from "./REOCOrderReport.vue?vue&type=template&id=c503b554&"
import script from "./REOCOrderReport.vue?vue&type=script&lang=ts&"
export * from "./REOCOrderReport.vue?vue&type=script&lang=ts&"
import style0 from "./REOCOrderReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
